import {getScaledBenchmarkCutlines} from "../../util/getScaledBenchmarkCutlines";
import getSeason from "../../util/getSeason";
import {getPR} from "../../functions/getPR";
import getWindowFromSeason from '../../util/getWindowFromSeason';

/**
 * Get the percentile rank and pacing of a student's score
 * @param {number} score 
 * @param {object} metric {value: string}
 * @param {object} benchmark {value: string, grade: number}
 * @param {object} customBenchmarks 
 * @param {string} locale 
 * @param {date} date 
 * @returns {object} An object containing the percentile and pacing of the student's score.
 */
export default function getPercentileRank(score, metric, benchmark, customBenchmarks, locale, date) {
  const scale = metric.value === 'ORF' ? 'WCPM' : metric.value;
  const season = getSeason(date);
  const window = getWindowFromSeason(season);
  const {cutoffs} = getScaledBenchmarkCutlines(benchmark, scale, season, customBenchmarks, locale);

  let pacing = "AT_GRADE_LEVEL";
  if (score >= cutoffs.GOOD) pacing = "AHEAD_OF_GRADE_LEVEL";
  if (score < cutoffs.POOR) pacing = "BELOW_GRADE_LEVEL";

  const percentile = getPR({
    score,
    scale: scale,
    grade: benchmark.grade,
    language: locale,
    window: window,
  });

  return {
    percentile,
    pacing,
  }
}